export default "__VITE_ASSET__CzApH$NQ__"